import React from 'react';
import MLDashboard from '../../components/ml/MLDashboard';

const MLDashboardPage = () => {
  return (
    <div>
      <MLDashboard />
    </div>
  );
};

export default MLDashboardPage;